<template>
    <div class="detail-customer-container Custom container h-100">
        <div class="content">
            <div class="header">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item>客户资料</el-breadcrumb-item>
                    <el-breadcrumb-item>客户详情</el-breadcrumb-item>
                </el-breadcrumb>
                <el-row>
                    <el-col :span="11" style="text-align: left">
                        <h1>{{ customer.name || '-' }}</h1>
                    </el-col>
                    <el-col :span="13" style="text-align: right">
                        客户名称：
                        <el-select v-model="customer_id" filterable placeholder="请选择客户" size="mini" clearable
                                   style="margin-right: 5px"
                                   @change="nextPage">
                            <el-option
                                    v-for="item in customerOption"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                            />
                        </el-select>
                        <el-button type="text" @click="nextPage(pre_id,'loadingPrevPage')" size="mini"
                                   :disabled="!pre_id"> 上一条
                        </el-button>
                        <el-button type="text" @click="nextPage(next_id,'loadingNextPage')" size="mini"
                                   :disabled="!next_id"> 下一条
                        </el-button>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="4" style="text-align: left">
                        <p><b>客户级别：</b>{{ customer.grade || '-' }} </p>
                    </el-col>
                    <el-col :span="4" style="text-align: left">
                        <p><b>客户行业：</b> {{ customer.trades || '-' }} </p>
                    </el-col>
                    <el-col :span="5" style="text-align: left">
                        <p><b>代理品牌：</b> {{ customer.brand_txt || '-' }}</p>
                    </el-col>
                    <el-col :span="4" style="text-align: left">
                        <p><b>开拓者：</b> {{ customer.pioneer_name || '-' }}</p>
                    </el-col>
                    <el-col :span="5" style="text-align: left">
                        <p><b>{{ '销\u3000\u3000售' }}：</b> {{ customer.sale || '-' }} </p>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="4" style="text-align: left">
                        <p><b>订单总数：</b>{{ customer.order_count || '-' }} </p>
                    </el-col>
                    <el-col :span="4" style="text-align: left">
                        <p><b>订单总金额：</b>{{ $utils.numberFormat(customer.order_sum_money, 2) }}</p>
                    </el-col>
                    <el-col :span="5" style="text-align: left">
                        <p><b>首次合作时间：</b> {{ customer.order_start_date || '-' }} </p>
                    </el-col>
                    <el-col :span="4" style="text-align: left">
                        <p><b>最新合作时间：</b> {{ customer.order_end_date || '-' }} </p>
                    </el-col>
                    <el-col :span="5" style="text-align: left">
                        <p><b>集团：</b> {{ customer.combine ? customer.combine.name : '-' }} </p>
                    </el-col>
                </el-row>
            </div>
            <div class="customer-tab">
                <el-tabs type="card" :active-name="tab" @tab-click="handleClick">
                    <el-tab-pane label="联系人" :name="MapTab.CONTACT">
                        <el-row style="text-align: left">
                            <el-button class="func-bars-add-button el-button--operation" style="padding: 6px"
                                       v-show="sale_id"
                                       @click="goEdit">编辑联系人信息
                            </el-button>
                        </el-row>
                        <div class="customer-contact" v-for="(contact,index) in customer.customer_contacts"
                             :key="index">
                            <div class="customer-contact-title">联系人{{ index + 1 }}</div>
                            <el-row class="customer-contact-row">
                                <el-col class="customer-contact-col" :span="8">
                                    <span style="color: rgb(254,45,84)">*</span>&nbsp;联系人姓名：{{
                                    contact.contact_name
                                    }}
                                </el-col>
                                <el-col class="customer-contact-col" :span="8">职位：{{
                                    contact.contact_position
                                    }}
                                </el-col>
                                <el-col class="customer-contact-col" :span="8">
                                    <span style="color: rgb(254,45,84)">*</span>&nbsp;联系电话：{{
                                    contact.contact_phone
                                    }}
                                </el-col>
                            </el-row>
                            <el-row class="customer-contact-row">
                                <el-col class="customer-contact-col" :span="8">
                                    <span style="color: rgb(254,45,84)">*</span>&nbsp;微信：{{
                                    contact.contact_wx || '-'
                                    }}
                                </el-col>
                                <el-col class="customer-contact-col" :span="8">&nbsp;&nbsp;省 / 市 /
                                    区：{{
                                    (contact.contact_province + contact.contact_city + contact.contact_area) ||
                                    '-'
                                    }}
                                </el-col>
                                <el-col class="customer-contact-col" :span="8">
                                    详细地址：{{ contact.contact_address || '-' }}
                                </el-col>
                            </el-row>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="历史订单" :name="MapTab.ORDER">
                        <el-form size="mini" :model="orderQuery" class="form" label-width="85px">
                            <el-row>
                                <el-col :span="4">
                                    <el-form-item label="红人名称">
                                        <el-select
                                                class="el-input-c"
                                                v-model="orderQuery.artist_id"
                                                filterable
                                                clearable
                                                size="mini"
                                                placeholder="请选择红人名称"
                                        >
                                            <el-option
                                                    v-for="(item, index) in artistOption"
                                                    :key="index"
                                                    :label="item.nickname"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="3">
                                    <el-form-item label="品牌" label-width="40px">
                                        <el-select filterable v-model="orderQuery.brand" size="mini" clearable>
                                            <el-option
                                                    v-for="item in brandOption"
                                                    :key="item"
                                                    :value="item"
                                                    :label="item"
                                            />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <el-form-item label="执行状态">
                                        <el-select v-model="orderQuery.bool_exec" size="mini" clearable>
                                            <el-option :value="1" label="已执行"/>
                                            <el-option :value="0" label="未执行"/>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <el-form-item label="执行人" label-width="55px">
                                        <el-select filterable v-model="orderQuery.executor_id" size="mini" clearable>
                                            <el-option
                                                    v-for="item in executorOption"
                                                    :key="item.id"
                                                    :value="item.id"
                                                    :label="item.name"
                                            />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-button type="primary" class="el-button--operation" size="mini"
                                               style="margin-left:20px;" @click="onSubmit">查询
                                    </el-button>
                                    <el-button @click="onReset" style="margin-right:0;" size="mini">重置</el-button>
                                </el-col>
                            </el-row>
                            <el-table
                                    id="orderTable"
                                    :data="orderTable"
                                    height="500"
                                    border
                                    style="width: 100%">
                                <el-table-column prop="customer.name" label="客户名称"
                                                 min-width="180"></el-table-column>
                                <el-table-column prop="customer.nature" label="客户性质" min-width="100"/>
                                <el-table-column prop="brand" label="品牌" min-width="100"/>
                                <el-table-column prop="release_timestamp" label="要求发布时间" min-width="120"/>
                                <el-table-column prop="artist.nickname" label="红人名称" min-width="100"/>
                                <el-table-column prop="payment_account" label="含税收入" min-width="100"/>
                                <el-table-column prop="sale.name" label="销售" min-width="100"/>
                                <el-table-column prop="executor.name" label="执行" min-width="100"/>
                                <el-table-column prop="order_exec.exec_timestamp" label="执行时间" min-width="100"/>
                                <el-table-column prop="exec_price" label="执行价" min-width="100"/>
                                <el-table-column prop="platforms" show-overflow-tooltip label="平台" min-width="100"/>
                                <el-table-column prop="created_at" label="下单时间" min-width="100"/>
                            </el-table>
                            <div>
                                <el-row>
                                    <el-col :span="24">
                                        <pagination
                                                :total.sync="params.total"
                                                :limit.sync="params.per_page"
                                                :page.sync="params.page"
                                                @pagination="getOrdersData"
                                        />
                                    </el-col>
                                </el-row>

                            </div>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="开票信息" :name="MapTab.INVOICE">
                        <el-row style="text-align: left">
                            <el-button class="func-bars-add-button el-button--operation" style="padding: 6px"
                                       v-show="sale_id"
                                       @click="goEdit">编辑开票信息
                            </el-button>
                        </el-row>
                        <div class="customer-contact" style="padding-top: 15px">
                            <el-row class="customer-contact-row">
                                <el-col class="customer-contact-col" :span="8">
                                    发票抬头：{{ customer.invoice_title || '-' }}
                                </el-col>
                                <el-col class="customer-contact-col" :span="8">税号：{{
                                    customer.tax_id || '-'
                                    }}
                                </el-col>
                                <el-col class="customer-contact-col" :span="8">
                                    客户电话:{{ customer.telephone || '-' }}
                                </el-col>
                            </el-row>
                            <el-row class="customer-contact-row">
                                <el-col class="customer-contact-col" :span="8">
                                    省/市/区：{{ customer.province + customer.city + customer.area || '-' }}
                                </el-col>
                                <el-col class="customer-contact-col" :span="8">详细地址：{{
                                    customer.address || '-'
                                    }}
                                </el-col>
                                <el-col class="customer-contact-col" :span="8">
                                    开户行:{{ customer.bank_name || '-' }}
                                </el-col>
                            </el-row>
                            <el-row class="customer-contact-row">
                                <el-col class="customer-contact-col" :span="8">银行卡号：{{
                                        customer.bank_amount || '-'
                                    }}
                                </el-col>
                                <el-col class="customer-contact-col" :span="8">
                                    发票类型：{{ invoiceTypeOption[customer.invoice_type] || '-' }}
                                </el-col>
                                <el-col class="customer-contact-col" :span="8">
                                    发票内容：{{ customer.invoice_content_txt || '-' }}
                                </el-col>
                            </el-row>
                            <el-row class="customer-contact-row">
                                <el-col class="customer-contact-col" :span="8">
                                    接收邮箱：{{ customer.invoice_email || '-' }}
                                </el-col>
                            </el-row>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="年框信息" :name="MapTab.YEAR_FRAME">
                        <el-empty v-if="sale_id &&customer.year_frame_basic === 'Y'&& customer.year_frame === 'N'"
                                  description="非年框客户"/>
                        <detail-custom-year-frame v-else ref="yearFrame"
                                                  :key="`${customer.pre_id}+${customer_id}+${customer.next_id}`"
                                                  :customer-id="customer_id"
                                                  :customer-name="customer.name||'-'"
                                                  :customer="customer"/>
                    </el-tab-pane>
                    <el-tab-pane v-if="!sale_id" label="销售人员" :name="MapTab.SALES">
                        <detail-sale-year-frame :key="customer_id" :customer-id="customer_id"/>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>
<script>
import {getOptionExecutor, getOptionItems} from '@/api/option'
import {getCustomersDetail, getCustomerOption, pageForCustomerSale} from "@/api/customers";
import {getFBoyOption} from "@/api/fboy";
import DetailCustomYearFrame from "./components/detailCustomYearFrame/index.vue";
import DetailSaleYearFrame from "./components/detailSalesYearFrame/index.vue";

const MapTab = {
    CONTACT: 'CONTACT',
    ORDER: 'ORDER',
    INVOICE: 'INVOICE',
    YEAR_FRAME: 'YEAR_FRAME',
    SALES: 'SALES',
}
export default {
    name: "CustomerDetail",
    components: {DetailSaleYearFrame, DetailCustomYearFrame},
    computed: {
        userAuth() {
            return this.$store.getters.getUserAuth
        }
    },
    data() {
        return {
            MapTab,
            tab: MapTab.CONTACT,
            customerOption: [],
            artistOption: [],
            executorOption: [],
            brandOption: [],
            invoiceContentOption: {},
            invoiceTypeOption: {
                spe_invoice: '电子专票',
                common_invoice: '电子普票',
            },
            loadingPrevPage: false,
            loadingNextPage: false,
            customer_id: 0,
            sale_id: 0,
            customer_sale_id: 0,
            pre_id: 0,
            next_id: 0,
            customer: {},
            orderQuery: {
                artist_id: '',
                brand: '',
                bool_exec: '',
                executor_id: '',
                sale_id: 0,
            },
            orderTable: [],
            params: {
                page: 1,
                per_page: 15,
                total: 0
            },
        };
    },
    watch: {
        '$route'() {
            this.init()
        }
    },
    created() {
        this.init()
        this.getOption()
        this.getOrdersData()
    },
    methods: {
        async init() {
            const _this = this
            const loading = _this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.9)'
            });
            const {id, sale_id, tab} = this.$route.query
            this.customer_id = Number.parseInt(id + '')
            this.sale_id = sale_id ? Number.parseInt(sale_id + '') : 0
            this.tab = tab || MapTab.CONTACT
            await Promise.all([this.getCustomDetail(), this.getCustomerOption()])
            this.handleClick({index: 0})
            loading.close();
        },
        getOption() {
            this.getFBoySelectList();
            this.getOptionExecutor();
            this.getOptionConfig();
        },
        //详情
        async getCustomDetail() {
            const res = await getCustomersDetail({id: this.customer_id, sale_id: this.sale_id || 0})
            this.customer = res.model
            this.customer.brand_txt = Array.isArray(this.customer.brand) ? this.customer.brand.join(' / ') : '-';
            this.customer.invoice_content_txt = Object.keys(this.invoiceContentOption).find(k => this.invoiceContentOption[k] === this.customer.invoice_content)
            this.pre_id = this.customer.pre_id
            this.next_id = this.customer.next_id
            this.brandOption = this.customer.brand
            this.customer_sale_id = res.model.customer_sale_id

            this.$nextTick(() => {
                this.$refs.yearFrame.init()
            })
        },
        async getOptionConfig() {
            const res = await getOptionItems(['invoice'])
            this.invoiceContentOption = res.model.invoice || {}
        },
        async getCustomerOption() {
            const _list = await getCustomerOption()
            if (Array.isArray(_list.model)) {
                this.customerOption = _list.model
            }
        },
        getFBoySelectList() {
            getFBoyOption({}).then((_list) => {
                if (Array.isArray(_list.model) && _list.model.length > 0) {
                    this.artistOption = _list.model
                }
            });
        },
        getOptionExecutor() {
            getOptionExecutor().then(res => {
                this.executorOption = res.model;
            });
        },
        handleSizeChange(val) {
            this.params.per_page = val
            this.getOrdersData()
        },
        handleCurrentChange(val) {
            this.params.page = val
            this.getOrdersData()
        },
        nextPage(id) {
            if (id) {
                const query = {...this.$route.query, ...{id}}
                this.$router.push({query})
            }
        },
        onSubmit() {
            this.params.page = 1;
            this.getOrdersData();
        },
        onReset() {
            this.orderQuery = {
                artist_id: '',
                brand: '',
                bool_exec: '',
                executor_id: '',
            };
            this.getOrdersData();
        },
        handleClick(tab) {
            const index = tab.index || '0'
            switch (index) {
                case '1':
                    this.getOption()
                    this.getOrdersData()
                    break;
                case '0':
                case '2':
                default:
                    break
            }
        },
        // 去编辑
        goEdit() {
            let id = this.customer_sale_id
            if (id) {
                const {href} = this.$router.resolve({
                    name: `editCustom`,
                    params: {id: id}//customer_id: row.customer_id, sale_id: row.sale_id
                });
                window.open(href, "_blank");
            }
        },
        getOrdersData() {
            let form = {
                ...{
                    page: this.params.page,
                    per_page: this.params.per_page,
                    customer_id: this.customer_id
                },
                ...this.orderQuery
            };
            pageForCustomerSale(form).then(res => {
                this.orderTable = res.model.data.data;
                this.customer.order_count = res.model.summary.order_count;
                this.customer.order_sum_money = res.model.summary.order_sum_money;
                this.customer.order_start_date = res.model.summary.order_start_date;
                this.customer.order_end_date = res.model.summary.order_end_date;
                this.params.total = res.model.data.total;
            });
        }
    }
};
</script>
<style scoped>
.header {
    background: #fff;
    padding: 10px 30px 0 30px;
}

.customer-tab {
    padding: 10px 24px;
    height: calc(100% - 186px);
    overflow: auto;
}

.customer-contact {
    margin-top: 10px;
    width: 90%;
    border: 1px solid #cfcfcf;
}

.customer-contact-title {
    height: 40px;
    line-height: 40px;
    background-color: #F2F2F2;
    text-align: left;
    padding-left: 20px;
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 15px;
}

.customer-contact-row {
    height: 40px;
    line-height: 40px;
    margin-bottom: 15px;
}

.customer-contact-col {
    text-align: left;
    padding-left: 20px;
    font-size: 14px;
}

.buttons a {
    font-size: 14px;
    font-weight: 400;
    color: rgba(4, 153, 255, 1);
    line-height: 20px;
    margin: 0 8px;
}

</style>
<style lang="scss">
.detail-customer-container {
  #orderTable thead tr, #orderTable thead th {
    height: 30px;
    line-height: 27px;
    background: #f9f9f9 !important;
    color: #313337 !important;
  }

  #order-pagination > ul > li.active {
    color: #FE2D54;
  }

  #orderTable > div.el-table__body-wrapper.is-scrolling-none > table > tbody > tr {
    height: 28px;
  }

  .el-tabs, .el-tab-pane {
    height: 100%;
  }

  .el-tabs__content {
    height: calc(100% - 56px);
  }
}
</style>
